export type ActivityClassification = 'conversation' | 'investigation' | 'file_change' | 'failed_attempt'

const editTools = new Set(['Edit', 'Write', 'MultiEdit'])

export function classifyActivity(tools: string[], toolActions: string | undefined): ActivityClassification {
  let actions: { tool?: string; result?: string; outcome?: string }[] = []
  try {
    const parsed = JSON.parse(toolActions || '[]')
    if (Array.isArray(parsed)) actions = parsed.filter(a => a && typeof a === 'object')
  } catch { /* Older hooks may not supply structured evidence. */ }
  if (actions.some(a => editTools.has(a.tool || '') && (a.outcome === 'success' || (typeof a.result === 'string' && a.result.startsWith('returned without a tool error'))))) return 'file_change'
  if (actions.some(a => a.outcome === 'error' || a.result === 'reported error')) return 'failed_attempt'
  return tools.length ? 'investigation' : 'conversation'
}

export function activityLabel(classification: string | null | undefined, kind: string | null | undefined) {
  switch (classification) {
    case 'conversation': return 'Conversation'
    case 'investigation': return 'Investigation'
    case 'file_change': return 'Files updated'
    case 'failed_attempt': return 'Attempt failed'
    default: return kind === 'completed_work' ? 'Recorded work' : 'Activity'
  }
}

export function summaryFailureLabel(reason: string | null | undefined) {
  if (reason === 'missing_provider_key') return 'Summary service is not configured.'
  if (reason === 'provider_timeout') return 'Summary service timed out.'
  if (reason === 'provider_network_error') return 'Could not reach the summary service.'
  if (reason?.startsWith('provider_http_')) return 'Summary service rejected the request.'
  if (reason) return 'Summary service did not return a usable summary.'
  return 'Waiting for the summary service.'
}
